import { is, query, xenv } from '@didi/webx-js'
import { PathDef, CheckFieldsDef } from '../defines'
import {
  TechPageErrorNotNormalXenv,
  TechPageErrorNoFromAndXenv,
  TechPageErrorFromError,
  TechPageErrorNoXenv,
  TechPageErrorXenvError,
  TechPageErrorXenvNotEqualUrl,
  TechPageErrorMiniQueryError,
  TechPageErrorIsOld,
  TechPageErrorIsNotChiTuUrl,
  TechPageErrorUrlNotHasKeyParams,
} from '../tech_error_track'

import { SupportXenvLists } from '../config/prod_config'
// 验证from
export const checkFrom = url => {
  const queryInfo = query(url)
  try {
    if (is('miniprogram') && !queryInfo.from && !queryInfo.xenv) {
      return TechPageErrorNoFromAndXenv()
    } else if (is('passenger') && queryInfo.from === 'xwebapp') {
      return TechPageErrorFromError()
    }
  } catch (err) {}
  return true
}
// 验证xenv
export const checkXenv = url => {
  const queryInfo = query(url)
  try {
    if (SupportXenvLists.indexOf(xenv()) < 0) {
      return TechPageErrorNotNormalXenv()
    }
    if (is('miniprogram') && !queryInfo.xenv) {
      return TechPageErrorNoXenv()
    } else if (is('miniprogram') && queryInfo.xenv === 'h5') {
      return TechPageErrorXenvError()
    } else if (is('miniprogram') && queryInfo.xenv !== xenv()) {
      return TechPageErrorXenvNotEqualUrl()
    }
  } catch (err) {}
  return true
}
// 小程序下需要的参数检查
export const checkMiniField = (fields, url) => {
  const queryInfo = query(url)
  try {
    fields.forEach(field => {
      if (is('miniprogram') && !queryInfo[field]) {
        return TechPageErrorMiniQueryError(`内嵌H5下缺少${field}`)
      }
    })
  } catch (err) {}
  return true
}

// 老页面
export const checkOldPath = () => {
  try {
    if (/[oO]ld/.test(window.location.pathname)) {
      return TechPageErrorIsOld()
    }
  } catch (err) {}
  return true
}

// 赤兔短链验证
export const checkPath = () => {
  try {
    // 内部跳转可以忽略
    const referrer = window?.document?.referrer
    if (referrer && referrer.includes('/quartz-mall/')) {
      return
    }
    if (query().prod_key !== 'quartz-mall') {
      return TechPageErrorIsNotChiTuUrl()
    }
  } catch (err) {}
  return true
}

export const checkQuery = key => {
  try {
    const querys = query()
    if (!querys[key]) {
      return TechPageErrorUrlNotHasKeyParams(`url中缺少: ${key}`)
    }
  } catch (err) {}
  return true
}

export function findPageDef(url) {
  url = url || window.location.href
  const pathDefKeys = Object.keys(PathDef)
  for (let i = 0; i < pathDefKeys.length; i++) {
    if (url.includes(PathDef[pathDefKeys[i]].path)) {
      return PathDef[pathDefKeys[i]]
    }
  }
}
export const checkByPagePath = pagePath => {
  const pageDef = pagePath ? PathDef[pagePath] : findPageDef()
  checkOldPath()
  if (!pageDef) {
    return
  }
  if (pageDef.shortLinkFlag) {
    checkPath()
  }
  const { miniRequiredFields = [], queryFields = [] } = CheckFieldsDef
  const { requiredQueryField } = pageDef
  // 检测必须带的参数
  if (requiredQueryField?.length) {
    requiredQueryField.forEach(item => {
      checkQuery(item)
    })
  }
  // 检验参数格式
  queryFields.forEach(item => {
    const checkMethods = `check${item
      .slice(0, 1)
      .toLocaleUpperCase()}${item.slice(1)}`
    if (typeof checkMethods === 'function') {
      checkMethods()
    }
  })
  // 小程序下内嵌H5
  miniRequiredFields.forEach(item => checkMiniField(item))
}
